module.exports = __webpack_public_path__ + "img/Multi.a7e6c201.png";